import { render, staticRenderFns } from "./Corretores.vue?vue&type=template&id=e2950790&"
import script from "./Corretores.vue?vue&type=script&lang=js&"
export * from "./Corretores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports